<template>
  <SortDropdown
    :items="sortValues"
    :animation="animation"
    data-test="sort-dropdown-button"
    class="x-z-[3]"
  >
    <template #toggle>
      <div
        class="x-button x-button-outlined x-text1 x-text1-sm x-flex x-items-center x-rounded-full x-border-0 x-border-lead-75 x-text-left desktop:x-text1-lg hover:x-border"
        :class="isMobile ? 'x-min-h-32 x-w-auto x-max-w-[117px] x-gap-4' : 'x-h-40'"
      >
        <SortIcon />
        <span class="x-line-clamp-1 x-font-bold x-text-lead-75">
          {{ $t('sort.label') }}
        </span>
      </div>
    </template>

    <template #item="{ isSelected, item }">
      <div
        class="x-facet-filter x-z-30 x-w-[222px] x-bg-neutral-0 x-px-16 x-text-neutral-100 hover:x-bg-neutral-25 hover:x-text-neutral-90"
        :class="{ 'x-bg-neutral-25': isSelected }"
      >
        <span class="x-text2 x-text2-sm">{{ $t(`sort.values.${item || 'default'}`) }}</span>
      </div>
    </template>
  </SortDropdown>
</template>

<script lang="ts">
import type { Sort } from '@empathyco/x-types'
import { AnimateScale, use$x } from '@empathyco/x-components'
import { SortDropdown } from '@empathyco/x-components/search'
import { defineComponent } from 'vue'
import { useDevice } from '../../composables/use-device.composable'
import SortIcon from '../icons/sort-icon.vue'

export default defineComponent({
  name: 'Sort',
  components: {
    SortIcon,
    SortDropdown,
  },
  setup() {
    const { isMobile } = useDevice()
    const sortValues: Sort[] = ['', 'price asc', 'price desc']
    const x = use$x()
    const animation = AnimateScale

    return {
      sortValues,
      isMobile,
      x,
      animation,
    }
  },
})
</script>
<style lang="scss">
.x-dropdown__items-list {
  width: 200px;
  text-align-last: start;
  right: 1px;
}
.x-dropdown__item {
  width: 100%;
}
</style>
